import * as React from 'react';

import { Logo } from 'components/ui';
import { PropsWithClassName } from 'types/common';

import { BaseLayout, Logout } from '../components';

import s from './MainLayout.module.scss';

const MainLayout: React.FC<React.PropsWithChildren<PropsWithClassName>> = ({
  className,
  children,
}) => {
  return (
    <BaseLayout
      className={className}
      header={
        <div className={s.layout__header}>
          <div className={s.layout__headerLeft}>
            <Logo className={s.layout__headerLeftLogo} />
          </div>
          <Logout />
        </div>
      }
    >
      {children}
    </BaseLayout>
  );
};

export default MainLayout;
